// EmailVerification.js - Updated version
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

function EmailVerification() {
    const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error', 'expired'
    const [message, setMessage] = useState('Verifying your email...');
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const verifyEmail = async () => {
            const token = searchParams.get('token');
            
            if (!token) {
                setStatus('error');
                setMessage('Invalid verification link. Please check your email or request a new one.');
                return;
            }

            try {
                // ❌ REMOVE THIS - Backend now redirects instead of returning JSON
                // const response = await axios.get(`http://localhost:3001/auth/verify-email?token=${token}`);
                
                // ✅ NEW APPROACH - Just redirect to the backend endpoint
                // Let the backend handle verification and redirect
                window.location.href = `${process.env.REACT_APP_API_URL}/auth/verify-email?token=${token}`;
                
            } catch (error) {
                console.error('Verification error:', error);
                setStatus('error');
                setMessage('Verification failed. Please try again or request a new verification email.');
            }
        };

        verifyEmail();
    }, [searchParams]);

    // This component might not render much since backend redirects
    return (
        <div className="verification-container">
            <div className="verification-content">
                {status === 'verifying' && (
                    <div className="verifying">
                        <div className="spinner"></div>
                        <h2>Verifying your email...</h2>
                        <p>Please wait while we verify your email address.</p>
                    </div>
                )}

                {status === 'error' && (
                    <div className="verification-error">
                        <h2>Verification Failed</h2>
                        <p>{message}</p>
                        <button onClick={() => navigate('/login')}>Go to Login</button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default EmailVerification;
